import { useContext, useEffect, useState } from "react"
import GridContainer from "./Components/grid/GridContainer"
import { GridButton } from "./Components/grid/GridButton"
import ButtonLightGray from "./Components/ButtonLightGray"
import { BoxButton } from "./Components/BoxButton"
import ChipFactory from "./Components/chips/ChipFactory"
import { IAdjudicationSolvedFilter } from "../../Store/Adjudication/types"
import AdjudicationSolvedDrawerMoreFilter from "./Components/drawer/AdjudicationSolvedDrawerFilter"
import ClearDbButton from "./Components/ClearDbButton"
import ConfirmationDialog from "../Misc/Dialog/ConfirmationDialog"
import { APIsContext } from "../../Store/APIs/context"
import { useSnackbar } from "notistack"

interface IAdjudicationSolvedFilterProps {
    onFilterApply: (filter: IAdjudicationSolvedFilter) => void
    filter: IAdjudicationSolvedFilter
}

const AdjudicationSolvedFilter: React.FC<IAdjudicationSolvedFilterProps> = (props) => {

    const apiState = useContext(APIsContext).state
    const [openMoreFilters, setOpenMoreFilters] = useState<boolean>(false)
    const [adjudicationSolvedFilter, setAdjudicationSolvedFilter] = useState<IAdjudicationSolvedFilter>(props.filter)
    const [clearDbOpen, setClearDbOpen] = useState(false)
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        setAdjudicationSolvedFilter(props.filter)
    }, [props.filter]);

    const setFilterChip = (filter: IAdjudicationSolvedFilter) => {
        props.onFilterApply(filter)
        setAdjudicationSolvedFilter(filter)
    }

    const resetFilter = () => {
        setAdjudicationSolvedFilter({})
        props.onFilterApply({})
    }

    const onFilterApply = (filter: IAdjudicationSolvedFilter) => {
        setAdjudicationSolvedFilter(filter)
        props.onFilterApply(filter);
        setOpenMoreFilters(false)
    }

    const handleDbClear = () => {
        apiState.AdjudicationApi.clearAdjudicationSolvedDb().then(res => {
            enqueueSnackbar("Cleared solved adjudication cases", {variant: "info"})
            resetFilter()
        }).catch(e => {
            if (e.message) {
                enqueueSnackbar(e.message, {variant: "error"})
            } else {
                enqueueSnackbar("Failed to clear solved adjudication cases database", {variant: "error"})
            }
        })
    }

    return (
        <>
        <GridContainer container style={{paddingTop: 0}}>
            <GridButton item xs={6}>
                <ChipFactory
                    filter={props.filter}
                    setChip={setFilterChip}
                    clearFilter={resetFilter}
                    style={{paddingTop: 0}}
                />
            </GridButton>
            <GridButton item xs={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                <ClearDbButton
                    onClick={() => setClearDbOpen(true)}
                    color="error"
                    variant="contained"
                >
                    Clear solved cases
                </ClearDbButton>
                <BoxButton>
                    <ButtonLightGray
                        onClick={() => setOpenMoreFilters(true)}
                        variant='text'
                        color="primary"
                        style={{height: "100%"}}
                    >
                        More filters
                    </ButtonLightGray>
                </BoxButton>
            </GridButton>
        </GridContainer>
        <AdjudicationSolvedDrawerMoreFilter
            anchor='right'
            filter={adjudicationSolvedFilter}
            setFilter={setAdjudicationSolvedFilter}
            open={openMoreFilters}
            onClose={() => setOpenMoreFilters(false)}
            resetFilter={resetFilter}
            onFilterApply={onFilterApply}
        />
        <ConfirmationDialog
            open={clearDbOpen}
            setOpen={setClearDbOpen}
            title="Clear solved cases"
            cancelText="Cancel"
            confirmText="Yes, clear solved cases"
            confirm={handleDbClear}
            confirmColor="error"
            text="This action will clear all data in the solved adjudication cases log"
        />
        </>
    )
}

export default AdjudicationSolvedFilter